import GameScene from "../../scenes/GameScene";
import DigitalWarrior from "../../sprites/DigitalWarrior";
import { AITargets } from "./DigitalWarriorAI";
import EnergyBallMachine, { EnergyBallMachineActions, EnergyBallMachineStates } from "../../sprites/EnergyBallMachine";

export default class EnergyBallMachineAI {
    scene: GameScene;
    opponent: EnergyBallMachine;
    player: DigitalWarrior;
    currentAction: EnergyBallMachineActions;
    currentState: EnergyBallMachineStates;
    awayDirection: Phaser.Math.Vector2;
    currentTarget: AITargets;

    constructor(scene: GameScene, opponent: EnergyBallMachine, player: DigitalWarrior){
        this.scene = scene;
        this.opponent = opponent;
        this.player = player;
        this.reset();
    }

    getCurrentTargetObject(){
        switch(this.currentTarget){
            case AITargets.PLAYER:
                return this.player;
            break;
            case AITargets.AWAY:
                return this.player;
            break;
        }
    }

    facingRightDirection(): boolean {
        const td = this.getTargetDirection();
        return (
            this.opponent.directionFacing.equals(td) ||
            this.opponent.directionFacing.y === td.y && td.x === 0 ||
            this.opponent.directionFacing.x === td.x && td.y === 0
        )
    }

    getTargetDirection(){
        const target = this.getCurrentTargetObject();
        const direction = new Phaser.Math.Vector2(0,0);
        if(target !== null){
            if(target.x > this.opponent.x)
                direction.x = 1;
            if(target.x < this.opponent.x)
                direction.x = -1;
            if(target.y > this.opponent.y)
                direction.y = 1;
            if(target.y < this.opponent.y)
                direction.y = -1;
        }
        if(this.currentTarget === AITargets.AWAY)
            direction.set(direction.x * -1, direction.y * -1);
        return direction;
    }

    reset(){
        this.currentTarget = AITargets.PLAYER;
        this.currentAction = EnergyBallMachineActions.IDLE;
        this.currentState = EnergyBallMachineStates.NORMAL;
        this.awayDirection = new Phaser.Math.Vector2(0,0);
    }

    update(time: number, delta: number){
        //if we're hit or dead you're not allowed to think.
        if(this.opponent.currentState === EnergyBallMachineStates.HIT || this.opponent.currentState === EnergyBallMachineStates.DEAD) return;
        switch(this.currentAction){
            case EnergyBallMachineActions.IDLE:
                if(this.opponent.canShoot()){
                    console.log("SHoot!");
                    this.currentAction = EnergyBallMachineActions.ATTACKING;
                }
            break;
            case EnergyBallMachineActions.ATTACKING:
                if(this.opponent.canShoot()){
                    console.log("SHOOTED");
                    const angle = Phaser.Math.Angle.BetweenPoints(this.opponent,this.player);
                    this.opponent.fireDirection.set(Math.cos(angle),Math.sin(angle));
                    this.opponent.setAction(EnergyBallMachineActions.ATTACKING);
                };
                this.currentAction = this.opponent.currentAction;
            break;
        }

    }

}